import React,{useState,useEffect} from 'react'

const UserMainComponent = () => {
  return (
    <div>UserMain Component</div>
  )
}

export default UserMainComponent